module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-four.d8cc2144.png";